import React, { RefObject, useState } from "react";
import { InfoCircle } from "react-bootstrap-icons";
import { StyledCheckbox } from "../../../../components/inputs/styledCheckbox";
import {
  LocationAccessForm,
  LocationAccessFormHandle,
} from "../../forms/locationAccessForm";
import { useTranslation } from "react-i18next";
import {
  ScheduleAccessForm,
  ScheduleAccessFormHandle,
} from "../../forms/scheduleAccessForm";
import {
  PagePasswordForm,
  PagePasswordFormRef,
} from "../../forms/pagePasswordForm";
import { useUserQuery } from "../../../../graphql/menu.hooks";
import { PageQuery } from "../../../../graphql/page.hooks";

type Props = {
  pageData: PageQuery;
  locationFormRef: RefObject<LocationAccessFormHandle>;
  scheduleFormRef: RefObject<ScheduleAccessFormHandle>;
  passwordFormRef: RefObject<PagePasswordFormRef>;
};

export const RestrictionsTab = ({
  locationFormRef,
  scheduleFormRef,
  passwordFormRef,
  pageData,
}: Props) => {
  const { t } = useTranslation();

  const { data: userData } = useUserQuery();
  const isPremiumUser = userData?.user?.activePremium || userData?.user?.admin;

  const [locationAccess, setLocationAccess] = useState<boolean>(
    pageData?.page?.pageLocationRestrictions?.isExactRequired || false
  );
  const [scheduleAccess, setScheduleAccess] = useState<boolean>(
    pageData?.page?.pageScheduleAssess?.scheduleAccess || false
  );
  const [pagePassword, setPagePassword] = useState<boolean>(
    pageData?.page?.pageRestriction?.checkboxPassword || false
  );

  return (
    <>
      <StyledCheckbox
        controlId="locationAccess"
        label={t("page.Location Access")}
        className={`restriction-checkbox mb-3 ${!locationAccess && "mb-md-4"}`}
        checked={locationAccess}
        onChange={() => setLocationAccess(!locationAccess)}
        tooltip={{
          text: t("page.locationAccessTooltip"),
          icon: <InfoCircle className="text-gray" />,
        }}
        disabled={!isPremiumUser}
      />
      {
        <LocationAccessForm
          ref={locationFormRef}
          isActive={locationAccess}
          locationRestriction={pageData?.page?.pageLocationRestrictions}
        />
      }
      <StyledCheckbox
        controlId="scheduleAccess"
        label={t("page.Schedule Access")}
        className={`restriction-checkbox mb-3 ${!scheduleAccess && "mb-md-4"}`}
        checked={scheduleAccess}
        onChange={() => setScheduleAccess(!scheduleAccess)}
        tooltip={{
          text: t("page.scheduleAccessTooltip"),
          icon: <InfoCircle className="text-gray" />,
        }}
        disabled={!isPremiumUser}
      />
      {
        <ScheduleAccessForm
          ref={scheduleFormRef}
          isActive={scheduleAccess}
          scheduleRestriction={pageData?.page?.pageScheduleAssess}
        />
      }
      <StyledCheckbox
        controlId="pagePassword"
        label={t("page.Page Password")}
        className={`restriction-checkbox mb-3 ${!pagePassword && "mb-md-4"}`}
        checked={pagePassword}
        onChange={() => setPagePassword(!pagePassword)}
        tooltip={{
          text: t("page.pagePasswordTooltip"),
          icon: <InfoCircle className="text-gray" />,
        }}
        disabled={!isPremiumUser}
      />
      {
        <PagePasswordForm
          ref={passwordFormRef}
          isActive={pagePassword}
          passwordRestriction={pageData?.page?.pageRestriction}
        />
      }
    </>
  );
};
